module.exports = __webpack_public_path__ + "static/media/overpass-regular.02d9e0ef.woff2";